import { render, staticRenderFns } from "./TaskActionButton.vue?vue&type=template&id=deb9bf0a&"
import script from "./TaskActionButton.vue?vue&type=script&lang=js&"
export * from "./TaskActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QLinearProgress,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QLinearProgress,QTooltip}, component.options.components || {})
